import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

type ButtonStyleProps = {
  fullwidth?: boolean;
};

const ButtonStyle = styled("button")<ButtonStyleProps>`
 position: relative;
  display: inline-block;
  cursor: pointer;
  outline: none;
  border: 0;
  vertical-align: middle;
  text-decoration: none;
  font-size: inherit;
  font-family: inherit;
  &.learn-more {
    font-weight: 600;
    color: $text;
    cursor: pointer;
    text-transform: uppercase;
    padding: 1.25em 2em;
    background: ${themeGet("colors.lightPink", "#fff")};
    border: 2px solid ${themeGet("colors.pinkBorder", "#fff")};
    border-radius: 0.75em;
    transform-style: preserve-3d;
    transition: transform 150ms cubic-bezier(0, 0, 0.58, 1),
      background 150ms cubic-bezier(0, 0, 0.58, 1);
    &::before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${themeGet("colors.darkPink")};
      border-radius: inherit;
      box-shadow: 0 0 0 2px ${themeGet("colors.pinkBorder", "#fff")},
        0 0.625em 0 0 ${themeGet("colors.pinkShadow")};
      transform: translate3d(0, 0.75em, -1em);
      transition: transform 150ms cubic-bezier(0, 0, 0.58, 1),
        box-shadow 150ms cubic-bezier(0, 0, 0.58, 1);
    }
    &:hover {
      background: ${themeGet("colors.pink")};
      transform: translate(0, 0.25em);
      &::before {
        box-shadow: 0 0 0 2px ${themeGet("colors.pinkBorder", "#fff")}, 0 0.5em 0 0 ${themeGet("colors.pinkShadow")};
        transform: translate3d(0, 0.5em, -1em);
      }
    }
    &:active {
      background: $pink;
      transform: translate(0em, 0.75em);
      &::before {
        box-shadow: 0 0 0 2px $pink-border, 0 0 ${themeGet("colors.pinkShadow")};
        transform: translate3d(0, 0, -1em);
      }
    }
  }
  span.btn-text {
    padding-left: 4px;
    padding-right: 4px;
  }
  span.btn-icon {
    display: flex;
    > div {
      display: flex !important;
    }
  }

  &:focus {
    outline: none;
  }

  &.disabled {
    color: ${themeGet("inactiveColor", "#767676")};
    background-color: ${themeGet("inactiveBG", "#e6e6e6")};
    border-color: ${themeGet("inactiveBG", "#e6e6e6")};

    &:hover {
      color: ${themeGet("inactiveColor", "#767676")};
      background-color: ${themeGet("inactiveBG", "#e6e6e6")};
      border-color: ${themeGet("inactiveBG", "#e6e6e6")};
    }
  }

  &.is-loading {
    .btn-text {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
`;

ButtonStyle.displayName = "ButtonStyle";

export default ButtonStyle;
